import { FC, useMemo } from "react";
import { Stack } from "@mui/material";
import { ColumnsInnerHeaderComponent } from "../../../common/ag-grid/components/ColumnsInnerHeaderComponent";
import { TypographyWithTooltip } from "../../../../common/TypographyWithTooltip";
import type { CustomHeaderProps } from "ag-grid-react";
import { money } from "@/utils/numeral/money";
import { generateTotalFromUniqueItemsByGridApiAndKey } from "@/components/pages/savings-opportunities/utils/helpers/generateTotalFromUniqueItemsByGridApiAndKey";

interface SavingsOpportunitiesMonthlySavingsHeaderProps
  extends CustomHeaderProps {
  infoIconTooltipText?: string;
}

export const SavingsOpportunitiesMonthlySavingsHeader: FC<
  SavingsOpportunitiesMonthlySavingsHeaderProps
> = ({ infoIconTooltipText, innerHeaderComponentParams, ...props }) => {
  const { approximate } = innerHeaderComponentParams ?? {};

  const total = useMemo(() => {
    return generateTotalFromUniqueItemsByGridApiAndKey(
      props.api,
      "monthly_savings",
    );
  }, [props.api]);

  const cost = money(total);

  return (
    <Stack position="relative">
      <ColumnsInnerHeaderComponent {...props} />

      <TypographyWithTooltip
        title={cost !== "N/A" && approximate ? `~${cost}` : cost}
        variant="caption"
        fontSize={10}
      />
    </Stack>
  );
};
